//================= [JS] ======================================
import {i18n} from '@/common/i18n';
import {Routes} from '@/common/enums/Routes';
//================= [VUE COMPONENTS] ==========================

// E00U6EKA5EGC — the 1:1 coaching: the coach's client list and rooms, the client's own room.
export const individualCoachingRoutes = [
  {
    path: i18n.global.t('routes.individualCoaching'),
    name: Routes.INDIVIDUAL_COACHING,
    component: () => import('@/components/individualCoaching/IndividualCoachingList.vue'),
    meta: {
      title: i18n.global.t('titles.individualCoaching'),
      active: 'individualCoaching',
      coaching: 'individualCoaching',
      userType: 'admin',
    },
  },
  {
    path: i18n.global.t('routes.individualCoachingClient'),
    name: Routes.INDIVIDUAL_COACHING_CLIENT,
    component: () => import('@/components/individualCoaching/IndividualCoachingRoom.vue'),
    props: true,
    meta: {
      title: i18n.global.t('titles.individualCoachingClient'),
      active: 'individualCoaching',
      coaching: 'individualCoaching',
      userType: 'admin',
    },
  },
  {
    path: i18n.global.t('routes.individualCoachingMine'),
    name: Routes.INDIVIDUAL_COACHING_MINE,
    component: () => import('@/components/individualCoaching/IndividualCoachingRoom.vue'),
    props: {id: 'me'},
    meta: {
      title: i18n.global.t('titles.individualCoachingMine'),
      active: 'individualCoaching',
      coaching: 'individualCoaching',
      layout: 'user',
    },
  },
];
